<template>
  <div v-if="isPC" class="home-pc">
    <div class="swiper">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide class="my-slide">
          <img
            v-if="locale === 'zh'"
            src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/home/banner_0.png"
          />
          <img
            v-else
            src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/home/banner_0_en.png"
          />
        </swiper-slide>
        <swiper-slide class="my-slide">
          <img
            v-if="locale === 'zh'"
            src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/home/banner_1.png"
          />
          <img
            v-else
            src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/home/banner_1_en.png"
          />
        </swiper-slide>
        <swiper-slide class="my-slide">
          <img
            v-if="locale === 'zh'"
            src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/home/banner_2.png"
          />
          <img
            v-else
            src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/home/banner_3_en.png"
          />
        </swiper-slide>
        <swiper-slide class="my-slide">
          <img
            v-if="locale === 'zh'"
            src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/home/banner_3.png"
          />
          <img
            v-else
            src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/home/banner_3_en.png"
          />
        </swiper-slide>
        <swiper-slide class="my-slide">
          <img
            v-if="locale === 'zh'"
            src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/home/banner_4.png"
          />
          <img
            v-else
            src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/home/banner_4_en.png"
          />
        </swiper-slide>
      </swiper>
      <div class="swiper-arrow">
        <div class="swiper-arrow-item" @click="swiperLeft()">
          <img src="../assets/left.svg" alt="" />
        </div>
        <div class="swiper-arrow-item" @click="swiperRight()">
          <img src="../assets/right.svg" alt="" />
        </div>
      </div>
      <div class="swiper-point">
        <span :class="activeIndex === 0 ? 'active' : ''"></span>
        <span :class="activeIndex === 1 ? 'active' : ''"></span>
        <span :class="activeIndex === 2 ? 'active' : ''"></span>
        <span :class="activeIndex === 3 ? 'active' : ''"></span>
        <span :class="activeIndex === 4 ? 'active' : ''"></span>
      </div>
    </div>
    <div class="banner">
      <img
        src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/home/photo.jpg"
        alt="photo"
      />
      <div class="posi-wrap">
        <p class="slogan">{{ $t("slogan_6") }}</p>
        <div class="more-btn" @click="go('/photo')">{{ $t("button_1") }}</div>
      </div>
    </div>
    <div class="banner">
      <img
        src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/home/laser.jpg"
        alt="laser"
      />
      <div class="posi-wrap">
        <p class="slogan">{{ $t("slogan_7") }}</p>
        <div class="more-btn" @click="go('/laser')">{{ $t("button_1") }}</div>
      </div>
    </div>
  </div>
  <div v-else class="home-mobile">
    <div class="swiper">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide class="my-slide">
          <img
            v-if="locale === 'zh'"
            src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/home/banner_mobile_0.png"
          />
          <img
            v-else
            src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/home/banner_mobile_0_en.png"
          />
        </swiper-slide>
        <swiper-slide class="my-slide">
          <img
            v-if="locale === 'zh'"
            src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/home/banner_mobile_1.png"
          />
          <img
            v-else
            src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/home/banner_mobile_1_en.png"
          />
        </swiper-slide>
        <swiper-slide class="my-slide">
          <img
            v-if="locale === 'zh'"
            src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/home/banner_mobile_2.png"
          />
          <img
            v-else
            src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/home/banner_mobile_2_en.png"
          />
        </swiper-slide>
        <swiper-slide class="my-slide">
          <img
            v-if="locale === 'zh'"
            src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/home/banner_mobile_3.png"
          />
          <img
            v-else
            src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/home/banner_mobile_3_en.png"
          />
        </swiper-slide>
        <swiper-slide class="my-slide">
          <img
            v-if="locale === 'zh'"
            src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/home/banner_mobile_4.png"
          />
          <img
            v-else
            src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/home/banner_mobile_4_en.png"
          />
        </swiper-slide>
      </swiper>
      <div class="swiper-point">
        <span :class="activeIndex === 0 ? 'active' : ''"></span>
        <span :class="activeIndex === 1 ? 'active' : ''"></span>
        <span :class="activeIndex === 2 ? 'active' : ''"></span>
        <span :class="activeIndex === 3 ? 'active' : ''"></span>
        <span :class="activeIndex === 4 ? 'active' : ''"></span>
      </div>
    </div>
    <div class="banner-wrap">
      <img
        src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/home/photo_mobile.png"
        alt="photo"
      />
      <div class="info-wrap">
        <p class="title">{{ $t("slogan_6_1") }}</p>
        <p class="title">{{ $t("slogan_6_2") }}</p>
        <div class="more-btn" @click="go('/photo')">{{ $t("button_1") }}</div>
      </div>
    </div>
    <div class="banner-wrap">
      <img
        src="https://hannto-orion.ks3-cn-beijing.ksyuncs.com/frontend/jiyin-official/home/laser_mobile.png"
        alt="laser"
      />
      <div class="info-wrap">
        <p class="title">{{ $t("slogan_7_1") }}</p>
        <p class="title">{{ $t("slogan_7_2") }}</p>
        <div class="more-btn" @click="go('/laser')">{{ $t("button_1") }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    const that = this;
    return {
      locale: localStorage.getItem("locale") || "zh",
      isPC: document.body.clientWidth > 768,
      activeIndex: 0,
      swiperOption: {
        speed: 500,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        loop: true,
        watchSlidesProgress: true,
        on: {
          slideChange: function () {
            that.activeIndex = this.realIndex;
          },
        },
      },
    };
  },
  created() {
    window.onresize = () => {
      this.isPC = document.body.clientWidth > 768;
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    go(path) {
      this.$router.push(path);
    },
    swiperLeft() {
      this.$refs.mySwiper.swiper.slidePrev();
    },
    swiperRight() {
      this.$refs.mySwiper.swiper.slideNext();
    },
  },
};
</script>
<style lang="less" scoped>
.home-pc {
  .swiper {
    position: relative;
    margin-bottom: 20px;
    .my-slide {
      width: 100%;
      aspect-ratio: 1920/830;
      img {
        width: 100%;
        display: block;
      }
    }
    .swiper-arrow {
      width: 100%;
      height: 44px;
      display: flex;
      justify-content: space-between;
      padding: 0 4.6875vw;
      position: absolute;
      top: 50%;
      left: 0;
      z-index: 99;
      margin-top: -22px;
      .swiper-arrow-item {
        width: 44px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border-radius: 50%;
        background-color: rgba(37, 44, 54, 0.2);
        &:hover {
          background-color: rgba(37, 44, 54, 0.3);
        }
        img {
          width: 20px;
        }
      }
    }
    .swiper-point {
      width: 84px;
      display: flex;
      position: absolute;
      left: 50%;
      bottom: 13px;
      z-index: 99;
      margin-left: -33px;
      span {
        width: 12px;
        height: 12px;
        margin-right: 6px;
        border-radius: 50%;
        background-color: rgba(0, 0, 0, 0.6);
        &.active {
          background-color: rgba(0, 0, 0, 0.2);
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .banner {
    aspect-ratio: 1920/830;
    position: relative;
    margin-bottom: 20px;
    img {
      width: 100%;
      display: block;
    }
    .posi-wrap {
      position: absolute;
      top: 15.06%;
      left: 19.948%;
      .slogan {
        font-size: 2.2917vw;
        font-weight: 500;
        color: #252c36;
        line-height: 1;
        margin-bottom: 1.927vw;
      }
      .more-btn {
        width: 6.6667vw;
        height: 2.0833vw;
        font-size: 0.8333vw;
        color: #f5f5f5;
        line-height: 2.0833vw;
        text-align: center;
        cursor: pointer;
        border-radius: 2.0833vw;
        background-color: #252c36;
        &:active {
          opacity: 0.6;
        }
        &:hover {
          background-color: #313a47;
        }
      }
    }
  }
}
.home-mobile {
  .swiper {
    position: relative;
    margin-bottom: 8px;
    .my-slide {
      width: 100%;
      aspect-ratio: 750/971;
      background-color: #f0f0f0;
      img {
        width: 100%;
        display: block;
      }
    }
    .swiper-point {
      width: 190px;
      display: flex;
      position: absolute;
      left: 50%;
      bottom: 20px;
      z-index: 99;
      margin-left: -75px;
      span {
        width: 30px;
        height: 3px;
        margin-right: 10px;
        background-color: rgba(0, 0, 0, 0.2);
        &.active {
          background-color: #63d1d6;
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .banner-wrap {
    width: 100%;
    aspect-ratio: 750/971;
    position: relative;
    margin-bottom: 8px;
    img {
      width: 100%;
      display: block;
    }
    .info-wrap {
      width: 100%;
      position: absolute;
      top: 48px;
      left: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      p {
        text-align: center;
        &.title {
          font-size: 25px;
          font-weight: 500;
          color: #262c35;
        }
      }
      .more-btn {
        width: 87px;
        height: 28px;
        margin-top: 28px;
        font-size: 12px;
        font-weight: 300;
        text-align: center;
        line-height: 28px;
        color: #f5f5f5;
        border-radius: 14px;
        background-color: #191919;
        &:active {
          opacity: 0.6;
        }
      }
    }
  }
}
</style>
